export type BlogPost = {
  slug: string;
  title: string;
  excerpt: string;
  coverImg: string;
  date: string;
  readTime: string;
  content: string[];
};

export const BLOG_POSTS: BlogPost[] = [
  {
    slug: "tabela-secerken-nelere-dikkat-edilmeli",
    title: "Tabela Seçerken Nelere Dikkat Edilmeli?",
    excerpt:
      "Doğru tabela seçimi, markanızın görünürlüğünü ve güven algısını doğrudan etkiler. Malzeme, konum, ışık ve tasarım dengesi kritik rol oynar.",
    coverImg: "/images/kharft/6-1.webp",
    date: "27 Mart 2026",
    readTime: "4 dk",
    content: [
      "Tabela, işletmenizin dışarıdaki ilk temsilcisidir. Bu nedenle sadece estetik değil, uzun ömür, okunabilirlik ve konum uyumu da birlikte değerlendirilmelidir.",
      "İlk adımda tabelanın kullanılacağı alanı doğru analiz etmek gerekir. Cadde üzerinde araç trafiği yoğun bir noktada kısa ve kalın yazı karakterleri daha etkili olurken, yaya trafiği yoğun bölgelerde detaylı içerik kullanılabilir.",
      "Malzeme seçimi uzun vadeli performansı belirler. Dış mekanda kompozit zemin, paslanmaz kutu harf veya kaliteli pleksi çözümler; güneş, yağmur ve rüzgar gibi etkilere karşı daha dirençlidir.",
      "Işıklı ya da ışıksız tercihinde çalışma saatleri belirleyicidir. Akşam saatlerinde aktif olan işletmeler için LED aydınlatmalı çözümler hem dikkat çeker hem de kurumsal görünümü güçlendirir.",
      "Son olarak tasarımın marka kimliğinizle uyumu önemlidir. Renkler, logo yerleşimi ve yazı karakteri; sosyal medya, kartvizit ve mağaza cephesiyle bütünlük taşımalıdır.",
    ],
  },
  {
    slug: "2026-dis-cephe-dekorasyon-trendleri",
    title: "2026 Dış Cephe Dekorasyon Trendleri",
    excerpt:
      "2026'da dış cephe dekorasyonunda sade çizgiler, doğal dokular ve ışıkla desteklenen modern yüzeyler öne çıkıyor.",
    coverImg: "/images/d/d-1.webp",
    date: "27 Mart 2026",
    readTime: "5 dk",
    content: [
      "Yeni dönemde dış cephe tasarımlarında temiz ve güçlü bir görünüm hedefleniyor. Fazla karmaşadan uzak, markayı net anlatan cephe kompozisyonları daha fazla tercih ediliyor.",
      "Ahşap doku görünümlü yüzeyler, antrasit tonları ve mat metal detaylar 2026'nın belirgin trendleri arasında. Bu kombinasyon, premium algıyı artırırken zamansız bir görünüm sağlar.",
      "Aydınlatma artık sadece gece görünürlüğü için değil, mimari vurgu için de kullanılıyor. Gizli LED hatları, cephede katman etkisi oluşturarak markanın fark edilmesini kolaylaştırıyor.",
      "Cephe kaplamada dayanıklılık da ön planda. UV dayanımı yüksek malzemeler ve düşük bakım gerektiren yüzeyler, işletmelerin uzun vadeli maliyetlerini düşürüyor.",
      "Doğru trend uygulaması için mekanın bulunduğu çevre, müşteri profili ve marka dili birlikte ele alınmalı. Böylece cephe hem modern hem de işlevsel hale gelir.",
    ],
  },
  {
    slug: "reklamciligin-yeni-gozdesi-led-ekranlar",
    title: "Reklamcılığın Yeni Gözdesi: LED Ekranlar",
    excerpt:
      "LED ekranlar, yüksek görünürlük ve dinamik içerik avantajı ile reklam iletişiminde güçlü bir dönüşüm sağlıyor.",
    coverImg: "/images/led/l-3.webp",
    date: "27 Mart 2026",
    readTime: "4 dk",
    content: [
      "Dijital reklam çözümleri arasında LED ekranlar, esnek içerik yönetimi sayesinde öne çıkıyor. Tek bir ekranda gün içinde farklı kampanyalar gösterilebilir.",
      "Parlaklık seviyesi yüksek olduğu için güneş altında bile görünürlük sunar. Bu özellik özellikle ana yol, kavşak ve yoğun yaya noktalarında ciddi bir avantaj sağlar.",
      "İçerik güncelleme hızı işletmelere operasyonel esneklik kazandırır. Fiyat değişimi, duyuru veya kampanya metni kısa sürede revize edilerek anında yayına alınabilir.",
      "Video, animasyon ve hareketli tipografi gibi formatlar dikkat süresini artırır. Bu da marka hatırlanırlığını klasik sabit tabelalara kıyasla yükseltir.",
      "LED ekran yatırımı planlanırken piksel aralığı, montaj yüksekliği, izleme mesafesi ve enerji tüketimi mutlaka profesyonel ekip tarafından değerlendirilmelidir.",
    ],
  },
];

export const getBlogPostBySlug = (slug: string) =>
  BLOG_POSTS.find((post) => post.slug === slug);
